import { render } from "./PenilaianKpi.vue?vue&type=template&id=2fdd4e2a"
import script from "./PenilaianKpi.vue?vue&type=script&lang=js"
export * from "./PenilaianKpi.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__